import {Link} from "react-router-dom";
import {downloadFile} from "../../fileDownloader";
import {Icon} from "antd";
import React from "react";

export const montarBotaoDescarregar = documento => {
    
    if (!documento.link && !documento.editor) {
        return (
            <Link
                className="botao-icon-download"
                to="#"
                onClick={() => downloadFile(documento.nome, documento.ficheiro)}
                title="Descarregar"
            >
                <Icon type="download" />
            </Link>
        );
    } else if (documento.link) {
        return (
            <a className="botao-icon-aceder" href={documento.ficheiro} target="_blank" rel="noopener noreferrer" title="Acessar">
                <Icon type="login" />
            </a>
        );
    } else {
        return (
            <Link
                className="botao-icon-aceder"
                to={`/turma-player/${this.props.match.params.turma
                    .replace(/[&\/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                    .toLowerCase()}/${documento.nome.replace(/[&\/\\#,+()$~%.'":*?!<>{}\s]/g, "-").toLowerCase()}/player-ficheiro`}
                onClick={() => localStorage.setItem("codigo_documento", documento.id)}
                title="Acessar"
            >
                <Icon type="login" />
            </Link>
        );
    }
};